
import { Platform } from '@angular/cdk/platform';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Device } from '@capacitor/device';
import { AuthService } from '../../core/services/auth.service';
import { EventService } from '../../core/services/event.service';
import { Location } from '@angular/common';
import { MatDrawer } from '@angular/material/sidenav';
import { PhotowallService } from 'src/app/core/services/photowall.service';
import { VersionService } from 'src/app/core/services/version.service';

@Component({
  selector: 'app-photowall-configuration',
  templateUrl: './photowall-configuration.component.html',
  styleUrls: ['./photowall-configuration.component.css']
})
export class PhotowallConfigurationComponent implements OnInit {
  eventName: any;
  version: string;
  isSavingData: boolean = false;
  constructor(private photoServive: PhotowallService,
    public dialog: MatDialog,
    private location: Location,
    private authService: AuthService,
    private router: Router,
    private platform: Platform, private versionService: VersionService
  ) {
    this.version = this.versionService.version;
  }
  @ViewChild('drawer') drawer1!: MatDrawer;
  isSmallScreen: boolean = false;
  showButtonGroup: boolean = false;

  toggleButtonGroup(): void {
    this.showButtonGroup = !this.showButtonGroup;
  }
  // Optionally listen to window resize events
  @HostListener('window:resize')
  onResize(event: any): void {
    this.updateButtonGroupVisibility();
    this.isSmallScreen = window.innerWidth < 600;
  }

  private updateButtonGroupVisibility(): void {
    //console.log(window.innerWidth);
    
    this.showButtonGroup = window.innerWidth > 600; // Example: show on wider screens (greater than 600px)

  }

  // @HostListener('window:resize', ['$event'])
  // onResize(event: any): void {
  //   this.isSmallScreen = window.innerWidth < 600; // Adjust breakpoint as needed
  // }

  async ngOnInit() {
    this.onResize(null); // Initialize on component load
    this.eventName = localStorage.getItem('name');
    // console.log(this.eventName); //__CONSOLE_LOG__

    // (await (this.photoServive.getEventQR(localStorage.getItem('e')))).subscribe({
    //   next: (res: any) => {
    //     console.log(res);
    //     if (res) {
    //       localStorage.setItem('qrcode', res.qrCode);
    //       localStorage.setItem('name', res.event_name);
    //       this.eventName = res.event_name;
    //     }
    //   }
    // });
    this.router.navigateByUrl('/photowall/upload-qrcode');
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  goHome() {
    localStorage.removeItem('eventId');
    localStorage.removeItem('e');
    localStorage.removeItem('savedHashtags');
    localStorage.removeItem('qrcode');

    this.router.navigateByUrl('/home');
  }

  logout() {
    this.authService
      .signOut()
      .then((res) => {
        this.router.navigateByUrl(
          "/auth/login"
        );
      })
      .catch((err) => {
        // console.error(err); //__CONSOLE_LOG__
      });
  }

  goBack() {
    localStorage.removeItem('eventId');
    localStorage.removeItem('e');
    localStorage.removeItem('savedHashtags');
    localStorage.removeItem('qrcode');

    this.router.navigateByUrl('/select-photowall');
  }

  eventSettings(hex: any) {
    localStorage.setItem('eventId', hex);
    this.router.navigateByUrl('/event-settings');
  }

  async downloadApp() {
    const info = await Device.getInfo();

    if (this.platform.IOS && info.model === 'iPhone' && info.platform === 'web') {
      window.location.href = 'https://apps.apple.com/in/app/picaggo/id1527686260';
    }

    if (this.platform.ANDROID && info.platform === 'web') {
      window.location.href = 'https://play.google.com/store/apps/details?id=application.share.photo.picaggo';
    }
    
    if (!this.platform.ANDROID && !this.platform.IOS && info.platform === 'web') {
      window.location.href = 'https://picaggo.com';
    }
  }

}
